function convertTimestampToFormattedString(timestamp) {
    const date = new Date(timestamp);
    const dateOptions = { month: 'long', day: 'numeric', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', dateOptions);
    return formattedDate;
};

function convertTimestampToTime(timestamp) {
    const date = new Date(timestamp);
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours %= 12;
    hours = hours ? hours : 12;
    const timeString = `${hours}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
    return timeString;
};

function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
}
const validatePhoneNumber = (number) => {
    const phoneNumberPattern = /^\(\d{3}\) \d{3}-\d{4}$/;
    return phoneNumberPattern.test(number);
  };
  
export {
    validatePhoneNumber,
    convertTimestampToFormattedString,
    convertTimestampToTime,
    toTitleCase
};